import { CancelButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { SimpleTableBase } from '@core/components/Table';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { formatPercentual } from '@format';
import { Competencia } from '@format/DATA';
import AtualizacaoMonetariaApi from 'app/services/api/AtualizacaoMonetariaApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext/GlobalContext';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

const IndiceMonetarioTable = () => {
  const [indiceMonetario] = useContext(GlobalContext).indiceMonetario;
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    carregandoRegistros: false,
    requestParams: {
      q: '',
    },
    page: {
      content: [],
      first: true,
      last: false,
      number: 0,
      size: 15,
      sort: 'UNSORTED',
      totalElements: 0,
      totalPages: 0,
    },
  });

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const initValue = {
    carregandoRegistros: false,
    requestParams: {
      q: '',
    },
    page: {
      content: [],
      first: true,
      last: false,
      number: 0,
      size: 15,
      sort: 'UNSORTED',
      totalElements: 0,
      totalPages: 0,
    },
  };

  useReduxLoading(loading);

  async function buscarVariacoes(params = initValue.page) {
    const buscar = async () => {
      try {
        setLoading(true);
        const resp = await AtualizacaoMonetariaApi.buscar({ ...params, q: indiceMonetario });
        setState({ ...state, page: resp.data });
      } catch (err) {
        apiUtils.handleApiError(err);
      } finally {
        setLoading(false);
      }
    };
    await buscar(params);
  }

  const buscar = async (params) => {
    await buscarVariacoes(params);
  };

  return (
    <SimpleTableBase
      hideSelection
      pageType="async"
      fetchOnCreate
      defaultSorting={[{ columnName: 'mesCompetencia', direction: 'desc' }]}
      columns={[
        {
          name: 'mesCompetencia',
          title: 'Mês/Ano',
          getCellValue: (data) => <div style={{ textAlign: 'center' }}>{Competencia(data.mesCompetencia) || '-'}</div>,
        },
        {
          name: 'variacaoMensal',
          title: 'Variação mensal',
          getCellValue: (data) => (
            <div style={{ textAlign: 'center' }}>
              {data.variacaoMensal ? `${formatPercentual(data.variacaoMensal)}%` : '-'}
            </div>
          ),
        },
        {
          name: 'indiceAcumulado',
          title: 'Índice acumulado',
          getCellValue: (data) => (
            <div style={{ textAlign: 'center' }}>
              {data.indiceAcumulado ? formatPercentual(data.indiceAcumulado) : '-'}
            </div>
          ),
        },
      ]}
      rows={state?.page?.content}
      loading={state?.carregandoRegistros}
      totalCount={state.page?.totalElements}
      searchBy={state?.requestParams?.q}
      fetchData={buscar}
      autoHeight
    />
  );
};

const IndicesMonetariosVisualizacaoModal = () => {
  const [indicesMonetariosModal, setIndicesMonetariosModal] = useContext(GlobalContext).indicesMonetariosModal;
  const [, setIndiceMonetario] = useContext(GlobalContext).indiceMonetario;

  const handleFecharModal = () => {
    setIndicesMonetariosModal(false);
    setIndiceMonetario(null);
  };

  return (
    <SimpleDialog open={indicesMonetariosModal === 'visualizarIndices'} onClose={() => handleFecharModal()}>
      <SimpleDialogContent
        header={{
          title: 'Atualização monetária',
          toolbar: (
            <>
              <CancelButton onClick={() => handleFecharModal()}>Fechar</CancelButton>
            </>
          ),
        }}
        content={<IndiceMonetarioTable />}
        contentStyle={{ padding: 0 }}
      />
    </SimpleDialog>
  );
};

export default IndicesMonetariosVisualizacaoModal;
